function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragAndDrop =
/**
 * @param {BrickFinder} draggable
 * @param {BrickFinder} dropzone
 * @param dragOverClass
 */
function DragAndDrop(draggable, dropzone) {
  var _this = this;

  var dragOverClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'drag-over';

  _classCallCheck(this, DragAndDrop);

  this.dragged = null;
  draggable.on.drag.start(function (event, target) {
    _this.handlers.start(target);

    _this.dragged = target;
  });
  dropzone.on.drag.end(function () {
    _this.handlers.end();

    _this.dragged = null;
  }).on.drag.over(function (event, target) {
    _this.handlers.over(target);

    event.preventDefault();
  }).on.drag.leave(function (event, target) {
    _this.handlers.leave(target);
  }).on.drag.drop(function (event, target) {
    if (_this.dragged !== null) {
      _this.handlers.drop(_this.dragged, target);

      _this.dragged = null;
    }
  });
  this.handlers = {
    start: function start(item) {},
    drop: function drop(item, target) {},
    over: function over(target) {
      return target.classList.add(dragOverClass);
    },
    leave: function leave(target) {
      return target.classList.remove(dragOverClass);
    },
    end: function end() {
      var _dropzone$filter$node;

      return (_dropzone$filter$node = dropzone.filter('.' + dragOverClass).node) === null || _dropzone$filter$node === void 0 ? void 0 : _dropzone$filter$node.classList.remove(dragOverClass);
    }
  };
  this.on = {
    start: function start(handler) {
      _this.handlers.start = handler;
      return _this;
    },
    drop: function drop(handler) {
      _this.handlers.drop = handler;
      return _this;
    },
    over: function over(handler) {
      _this.handlers.over = handler;
      return _this;
    },
    leave: function leave(handler) {
      _this.handlers.leave = handler;
      return _this;
    },
    end: function end(handler) {
      _this.handlers.end = handler;
      return _this;
    }
  };
};

export { DragAndDrop as default };